(function () {
  function initTopNav() {
    var nav = document.querySelector('[data-mih-topnav]');
    if (!nav) return;

    var items = nav.querySelectorAll('[data-mih-nav-item]');
    var openItem = null;

    // Move every dropdown menu out of the (overflow-x: auto) nav scroller
    // and onto <body>, so it can't get clipped on mobile. Remember the
    // owning item via data-attr so we can find it again.
    items.forEach(function (item, i) {
      var menu = item.querySelector('[data-mih-nav-menu]');
      if (!menu) return;
      menu.setAttribute('data-mih-nav-menu-owner', i);
      item.setAttribute('data-mih-nav-item-id', i);
      if (menu.parentElement !== document.body) {
        document.body.appendChild(menu);
      }
    });

    function menuFor(item) {
      var id = item.getAttribute('data-mih-nav-item-id');
      return document.querySelector('[data-mih-nav-menu-owner="' + id + '"]');
    }

    function positionMenu(item) {
      var trigger = item.querySelector('[data-mih-nav-trigger]');
      var menu = menuFor(item);
      if (!trigger || !menu) return;

      var rect = trigger.getBoundingClientRect();
      var viewportW = document.documentElement.clientWidth || window.innerWidth;
      var minWidth = Math.max(Math.round(rect.width), 240);
      var maxWidth = viewportW - 16;
      var width = Math.min(minWidth, maxWidth);
      var left = Math.round(rect.left);
      if (left + width > viewportW - 8) left = Math.max(8, viewportW - 8 - width);
      if (left < 8) left = 8;

      menu.classList.add('is-fixed');
      menu.style.position = 'fixed';
      menu.style.top = Math.round(rect.bottom) + 'px';
      menu.style.left = left + 'px';
      menu.style.minWidth = width + 'px';
      menu.style.zIndex = '99999';
    }

    function resetMenu(item) {
      var menu = menuFor(item);
      if (!menu) return;
      menu.classList.remove('is-fixed');
      menu.style.top = '';
      menu.style.left = '';
      menu.style.minWidth = '';
      menu.style.position = '';
      menu.style.zIndex = '';
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (except && item === except) return;
        item.classList.remove('is-open');
        resetMenu(item);
        var trigger = item.querySelector('[data-mih-nav-trigger]');
        var menu = menuFor(item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
      if (!except) openItem = null;
    }

    function openMenu(item) {
      closeAll();
      var trigger = item.querySelector('[data-mih-nav-trigger]');
      var menu = menuFor(item);
      if (!trigger || !menu) return;

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      positionMenu(item);
      openItem = item;
    }

    // Desktop = devices with fine pointer (mouse) and real hover capability.
    // Touch-only devices (phones/tablets) keep click-to-toggle so accidental
    // taps don't open menus on scroll.
    var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var HOVER_CLOSE_DELAY = 180;
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }
    function scheduleClose(item) {
      cancelClose();
      closeTimer = setTimeout(function () {
        if (openItem === item) closeAll();
      }, HOVER_CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mih-nav-trigger]');
      var menu = menuFor(item);
      if (!trigger || !menu) return;

      trigger.style.touchAction = 'manipulation';

      // Click toggles (works for touch + keyboard + as a fallback on desktop)
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (item.classList.contains('is-open')) {
          closeAll();
        } else {
          openMenu(item);
        }
      });

      if (hoverCapable) {
        // Hover open on the trigger
        item.addEventListener('mouseenter', function () {
          cancelClose();
          if (openItem !== item) openMenu(item);
        });
        // Allow brief mouse travel from trigger → menu without closing
        item.addEventListener('mouseleave', function () {
          scheduleClose(item);
        });
        // Keep open while cursor is over the (body-portaled) menu
        menu.addEventListener('mouseenter', cancelClose);
        menu.addEventListener('mouseleave', function () {
          scheduleClose(item);
        });
      }
    });

    function onViewportChange() {
      if (openItem) positionMenu(openItem);
    }

    window.addEventListener('scroll', onViewportChange, true);
    window.addEventListener('resize', onViewportChange);

    document.addEventListener('click', function (event) {
      var insideNav = nav.contains(event.target);
      var insideMenu = false;
      items.forEach(function (item) {
        var m = menuFor(item);
        if (m && m.contains(event.target)) insideMenu = true;
      });
      if (!insideNav && !insideMenu) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopNav);
  } else {
    initTopNav();
  }
})();
